//  * 파일 전송 메뉴에서 사용
/**
 * 경로에서 마지막 세그먼트를 제외한 부모 경로를 반환
 * @param {string} path - 원본 경로
 * @returns {string} 부모 경로
 */
export function getParentPath(path) {
  // 루트 경로인 경우
  if (path === '/' || path === '') {
    return '/';
  }
  // 마지막 슬래시 제거 (있는 경우)
  const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;

  // 마지막 슬래시의 위치 찾기
  const lastSlashIndex = normalizedPath.lastIndexOf('/');

  // 부모 경로 계산
  if (lastSlashIndex <= 0) {
    return '/'; // 최상위 경로의 부모는 항상 루트
  }

  return normalizedPath.slice(0, lastSlashIndex);
}

/**
 * 경로에서 마지막 세그먼트만 반환하는 함수
 * @param {string} path - 원본 경로
 * @returns {string} 마지막 세그먼트
 */
export function getLastSegment(path) {
  // 루트 경로인 경우
  if (path === '/' || path === '') {
    return '';
  }

  // 마지막 슬래시 제거 (있는 경우)
  const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;
  // 마지막 슬래시의 위치 찾기
  const lastSlashIndex = normalizedPath.lastIndexOf('/');
  // 마지막 세그먼트 반환
  if (lastSlashIndex < 0) {
    return normalizedPath;
  }

  return normalizedPath.slice(lastSlashIndex + 1);
}
